import { FlexColMd, FlexColSm, FlexLgAlignCenter, Headline2 } from 'components/Elements';
import Hint from '../../../components/Hint';

type CourseStepContentProps = {
    title?: string;
    hint?: string;
    content: JSX.Element;
};

export default function CourseStepContent({ title, hint, content }: CourseStepContentProps): JSX.Element {
    return (
        <FlexColMd>
            {(title || hint) && (
                <FlexColSm>
                    {title && (
                        <FlexLgAlignCenter>
                            <Headline2>{title}</Headline2>
                        </FlexLgAlignCenter>
                    )}
                    {hint && <Hint hint={hint} />}
                </FlexColSm>
            )}

            {content}
        </FlexColMd>
    );
}
